import { TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React from "react";
import { Controller } from "react-hook-form";

export const TimeInput = (props) => {
  const { label, fullWidth, endIcon, name, type, errors, control, ...rest } =
    props;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field, fieldState }) => {
        return (
          <TimePicker
            {...field}
            {...rest}
            fullWidth={fullWidth}
            label={label}
            slotProps={{
              textField: {
                variant: "filled",
                fullWidth: true,
                error: fieldState.invalid,
                helperText: fieldState.error?.message,
              },
            }}
            sx={{
              "& .MuiFilledInput-root:before": {
                borderBottom: 0,
              },
              "& .MuiFilledInput-root:before:hover": {
                borderBottom: "0 !important",
              },
            }}
            value={dayjs(field.value)}
          />
        );
      }}
    />
  );
};
